module.exports = __webpack_public_path__ + "img/hero-image-03-fi.88f8cb20.png";